module.exports = __webpack_public_path__ + "1953b1f7.png";